var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocusAreaSpokenProductionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1433_23261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 6.66634H33.334V26.6663H8.61732L6.66732 28.6163V6.66634ZM6.66732 3.33301C4.83398 3.33301 3.35065 4.83301 3.35065 6.66634L3.33398 36.6663L10.0007 29.9997H33.334C35.1673 29.9997 36.6673 28.4997 36.6673 26.6663V6.66634C36.6673 4.83301 35.1673 3.33301 33.334 3.33301H6.66732ZM10.0007 19.9997H23.334V23.333H10.0007V19.9997ZM10.0007 14.9997H30.0007V18.333H10.0007V14.9997ZM10.0007 9.99967H30.0007V13.333H10.0007V9.99967Z",
    fill: "url(#paint0_linear_1433_23261)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_23261",
    x1: 4.00195,
    y1: 3.99902,
    x2: 36.002,
    y2: 35.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1433_23261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusAreaSpokenProductionIcon);
export default __webpack_public_path__ + "static/media/FocusAreaSpokenProductionIcon.5b45cd54af70a73a4ffb3186dc061b78.svg";
export { ForwardRef as ReactComponent };